// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__FI1Mi","OrderButton":"BuildControls_OrderButton__2EqVZ","enable":"BuildControls_enable__2knuQ"};